<template>
  <v-card-text class="title font-weight-light text-left">  

      <v-row v-if="target.startsWith('img')" align="center" justify="center" >
        
          <v-img :src="target" height="250px" contain class=""></v-img>                     
      </v-row>
      <v-row v-else align="center" justify="center" style="height: 250px;">
        <span class="display-1" style="color:blue;"><b>{{target}}</b></span>
      </v-row>

  </v-card-text>
</template>

<script>

export default {
  name: 'CardTextDisplayOption',
  props: ['target'],
  data: () => ({
    }),
  };
</script>

<style>
.custom-card{
  font-family: auto;
}
.v-card__text{
  color: black !important;
}

</style>

